import React from 'react';

import DashboardPreferences from './dashboard-preferences';
import ProjectPreferences from './project-preferences';

import icons from '../../assets/icons';

const Preferences = ({ onChange }) => {
  return (
    <div className="profile-cards preferences">
      <div className="card">
        <div className="card-header">
          <img src={icons.settingsDark} alt="user icon" />
          <h3>Preferences</h3>
        </div>
        <div className="card-body">
          <DashboardPreferences />
          <ProjectPreferences onChange={onChange} />
        </div>
      </div>
    </div>
  );
};

export default Preferences;
